module.exports = __webpack_public_path__ + "img/op1.dadc68b2.png";